import React from 'react';

import Loading from './loading/Loading.component';
import Popup from 'react-popup';
import ReactDom from 'react-dom';


import UserInstructions from './user-instructions/UserInstructions.component';
import DynamicLinkTable from './dynamic-link-table/DynamicLinkTable.component';
import AlternateTimeDisclaimer from './alternate-time-disclaimer/AlternateTimeDisclaimer.component';


import Invalid from './invalid/Invalid.component';
import Expired from './expired/Expired.component';
import Error from './error/Error.component';
import Retry from './retry/Retry.component';
import Badrequest from './badrequest/Badrequest.component';

import './Popup.component.css'
import { appointmentService } from './Appointment.service';

ReactDom.render(
    <Popup />,
    document.getElementById('popupContainer')
);
export default class ContentArea extends React.Component {
    state = {
        loading: true,
        submitting: false,
        orderIdsToIgnore: []
    };

    constructor(props) {
        super(props);

        this.loadOrderList([]);

        this.loadOrderList = this.loadOrderList.bind(this);

        this.handleOrderChange = this.handleOrderChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleConfirmAll = this.handleConfirmAll.bind(this);
        this.handleClear = this.handleClear.bind(this);

        this.renderArea = this.renderArea.bind(this);
        this._renderLoadingArea = this._renderLoadingArea.bind(this);
        this._renderContentArea = this._renderContentArea.bind(this);
        this._renderErrorArea = this._renderErrorArea.bind(this);
    }

    async loadOrderList() {
        this.setState({
            orderList: [],
            loading: true
        });

        try {
            let tableInformation = await appointmentService.getTableInformation();
            let orderList = tableInformation.orders;
            const headers = tableInformation.headers;
            let errorText = tableInformation.error;
            const appointmentErrors = tableInformation.appointmentErrors;

            orderList = orderList.filter((order) => !this.state.orderIdsToIgnore.includes(order.orderId));

            switch (errorText) {
                case null:
                    //this is good state
                    this.setState({
                        orderList,
                        headers,
                        appointmentErrors,
                        loading: false
                    });
                    break;
                case "Invalid":
                    this.setState({
                        invalid: true,
                        loading: false
                    });
                    break
                case "Expired":
                    this.setState({
                        expired: true,
                        loading: false
                    });
                    break
                default:
                    this.setState({
                        error: true,
                        loading: false
                    });
                    break;
            }
        } catch(error) {
            switch (error.status) {
                case 429:
                    this.setState({
                        retry: true,
                        loading: false
                    })
                    break;
                case 400:
                    this.setState({
                        badrequest: true,
                        loading: false
                    })
                    break;
                default:
                    setTimeout(() => {
                        this.setState({
                            error: true,
                            loading: false
                        });
                    }, 10000);
                    break;
            }
        }
    }

    handleOrderChange(index, newValue) {
        const order = this.state.orderList[index];
        for (var attrname in newValue) {
            order[attrname] = newValue[attrname];

            if (attrname === 'confirmed' && newValue[attrname] === false) {
                this.setState({
                    confirmAll: false
                });
            }
        }

        this.setState({
            orderList: this.state.orderList,
            appointmentErrors: this.state.appointmentErrors
        });
    }

    async handleSubmit() {
        this.setState({
            submitting: true
        });

        let result;
        try {
            result = await appointmentService.submitOrders(this.state.orderList);
            if (result.unsuccessfulOrders.length > 0) {
                const orderIds = result.unsuccessfulOrders.map((order) => order.orderId);
                Popup.alert(`There were issues confirming the following orders: ${orderIds.join(', ')}. Please respond to the email.`, 'Not Successful');
            } else {
                Popup.alert('Orders confirmed successfully!', "Success!");
                const orderIds = result.successfulOrders.map((order) => order.orderId);

                this.setState({
                    orderIdsToIgnore: this.state.orderIdsToIgnore.concat(orderIds)
                }, () => this.loadOrderList());
            }
        } catch {
            Popup.alert('There was a problem trying to confirm your orders. Please respond to the email.', "Problem - Not Successful");
        }

        this.setState({
            submitting: false
        });
    }

    handleConfirmAll() {
        this.state.orderList.forEach(appointment => {
            appointment.confirmed = true
        });

        this.setState({
            orderList: this.state.orderList,
            appointmentErrors: this.state.appointmentErrors
        });
    }

    handleClear() {
        this.state.orderList.forEach( (order) => {
            order.confirmed = false;
            order.appointmentReferenceNumber = '';
            order.preloadedEquipmentDecalId = '';
            order.preloadEquipmentError = false;
            order.selectedAppointmentSuggestionIndex = 0;
        });

        this.setState({
            orderList: this.state.orderList,
            appointmentErrors: this.state.appointmentErrors
        });
    }

    renderArea() {
        if (this.state.loading) {
            return this._renderLoadingArea();
        }

        if (this.state.invalid) {
            return this._renderInvalidArea();
        }

        if (this.state.expired) {
            return this._renderExpiredArea();
        }

        if(this.state.retry) {
            return this._renderRetryArea();
        }

        if (this.state.error) {
            return this._renderErrorArea();
        }
        if (this.state.badrequest) {
            return this._renderBadRequestArea();
        }

        return this._renderContentArea();
    }

    _renderLoadingArea() {
        return (
            <Loading />
        );
    }

    _renderContentArea() {
        return (
            <div>
                <UserInstructions
                    onTimeExpires={ this.loadOrderList }
                />
                <DynamicLinkTable
                    orderList={ this.state.orderList }
                    appointmentErrors={this.state.appointmentErrors}
                    appointmentErrorDisplayed={false}
                    headers={ this.state.headers }
                    isSubmitting={ this.state.submitting }
                    onOrderChange={ this.handleOrderChange }
                    onConfirmAll={ this.handleConfirmAll }
                    onSubmit={ this.handleSubmit }
                    onClear={ this.handleClear } />
                <AlternateTimeDisclaimer />
            </div>
        );
    }

    _renderInvalidArea() {
        return (
            <Invalid />
        );
    }
    _renderBadRequestArea() {
        return (
            <Badrequest />
        );
    }

    _renderExpiredArea() {
        return (
            <Expired />
        );
    }

    _renderErrorArea() {
        return (
            <Error />
        );
    }

    _renderRetryArea() {
        return (
            <Retry />
        );
    }

    render() {
        return (
            <div>
                { this.renderArea() }
            </div>
        );
    }
}